import { Directive, input, InputSignal, inject, DestroyRef, effect } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { ScreenReaderService } from '../../services/screen-reader.service';

@Directive({
  selector: '[tdWbScreenReaderVisibility]'
})
export class ScreenReaderVisibilityDirective{
  readonly tdWbScreenReaderVisibility: InputSignal<boolean> = input(false);

  private ariaHiddenElements: Map<Element, string> = new Map<Element, string>();

  private readonly destroyRef = inject(DestroyRef);
  private readonly document = inject(DOCUMENT);

  constructor() {
    // effect: imperatively sets aria-hidden on non-overlay DOM elements via
    // ScreenReaderService — DOM attribute mutation cannot be expressed as a
    // template binding because the targets are outside this component's tree.
    effect(() => {
      const visible = this.tdWbScreenReaderVisibility();
      this.toggleNonOverlayContentScreenReaderVisibility(!visible);

    });
    this.destroyRef.onDestroy(() => {
      this.toggleNonOverlayContentScreenReaderVisibility(true);
    });
  }

  private toggleNonOverlayContentScreenReaderVisibility(visible: boolean): void {
    if (visible) {
      ScreenReaderService.contentVisible(this.ariaHiddenElements);
    } else {
      const overlayContainer = this.document.getElementsByClassName('cdk-overlay-container');
      if (overlayContainer !== undefined && overlayContainer !== null && overlayContainer.length > 0) {
        ScreenReaderService.contentHidden(overlayContainer[0] as HTMLElement, this.ariaHiddenElements);
      }
    }
  }
}
